import { render, staticRenderFns } from "./HearthstoneHero.vue?vue&type=template&id=5157444d&scoped=true"
import script from "./HearthstoneHero.vue?vue&type=script&lang=js"
export * from "./HearthstoneHero.vue?vue&type=script&lang=js"
import style0 from "./HearthstoneHero.vue?vue&type=style&index=0&id=5157444d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157444d",
  null
  
)

export default component.exports